import About from "./components/About/about"
import Navbar from "./components/Navbar/navbar"
import Footer from "./components/Footer/footer"
import Home from "./components/Home/Home"
import Works from "./components/Works/works"
import{useState} from "react"
import "./app.scss"
import Menu from "./components/Menu/menu"

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="App">
      <Navbar menuOpen ={menuOpen} setMenuOpen= {setMenuOpen}/>
      <Menu menuOpen ={menuOpen} setMenuOpen= {setMenuOpen}/>
      <div className="sections">
        <Home/>
        <About/>
        <Works/>
        <Footer/>
      </div>
    </div>
  );
}

export default App;
